import {EdcUiThemeConfig} from './edc-ui-theme-config';

export const SOVITY_THEME: EdcUiThemeConfig = {
  theme: 'theme-sovity',
  brandFaviconSrc: '/assets/images/sovity_favicon-192x192.png',
  brandLogoSrc: '/assets/images/sovity_logo.svg',
  brandLogoStyle: 'width: 70%;',
};

export const MDS_THEME: EdcUiThemeConfig = {
  theme: 'theme-mds',
  brandFaviconSrc: '/assets/images/mds_favicon.ico',
  brandLogoSrc: '/assets/images/mds_logo.svg',
  brandLogoStyle: 'height: 57px; margin-top: 5px; margin-left: 5px;',
};
